import "@/styles/partials/comments.css";

const commentsContainer = document.querySelector("#comments-container");
const paginateButton = document.querySelector("#comments-paginate-btn");

const pageLength = 5;
let page = 1;

if (paginateButton) {
  paginateButton.addEventListener("click", () => paginate(++page));
}

function paginate(toPage) {
  const firstHiddenComment = commentsContainer.querySelector(
    `li:nth-of-type(${pageLength * toPage + 1})`,
  );
  if (firstHiddenComment) {
    firstHiddenComment.before(paginateButton);
  } else {
    commentsContainer.append(paginateButton);
  }
}

if (commentsContainer) {
  paginate(page);
  document.querySelector("#commentform").removeAttribute("novalidate");
}

const commentFormButton = document.querySelector("#comment-form-button");
const commentFormContainer = document.querySelector("#comment-form-container");
const commentForm = document.querySelector("#respond");

if (commentFormButton) {
  commentFormButton.addEventListener("click", showContactForm);
}

function showContactForm() {
  if (commentFormContainer.contains(commentForm)) {
    commentFormContainer.classList.toggle("hidden");
  } else {
    commentFormContainer.classList.remove("hidden");
    commentFormContainer.prepend(commentForm);
  }
}
